//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SelectField from '@/components/d0822/fields/selectField.vue';
import filterMixin from '@/mixins/filter';
import FiltersMobileModal from './filtersMobileModal.vue';
import viewportMixin from '@/mixins/viewport.mixin';

export default {
  components: { SelectField, FiltersMobileModal },
  mixins: [filterMixin, viewportMixin],
  computed: {
    search: {
      get() {
        return this.filter.search;
      },
      set(payload) {
        return this.filterFieldUpdate('search', payload);
      },
    },
    directions: {
      get() {
        return this.filter.directions;
      },
      set(payload) {
        return this.filterFieldUpdate('directions', payload);
      },
    },
    types: {
      get() {
        return this.filter.types;
      },
      set(payload) {
        return this.filterFieldUpdate('types', payload);
      },
    },
    status: {
      get() {
        return this.filter.status;
      },
      set(payload) {
        return this.filterFieldUpdate('status', payload);
      },
    },
  },
  created() {
    this.createFilter('eventList', [
      { name: 'search', clearable: true, urlQuery: true },
      {
        name: 'directions',
        array: true,
        clearable: true,
        urlParam: true,
        urlParamReplace: true,
        urlValueGetter: 'eventsList/GET_DIRECTION_SLUG_FROM_ID',
        serverValueGetter: 'eventsList/GET_DIRECTION_ID_FROM_SLUG',
      },
      { name: 'types', urlQuery: true, array: true, clearable: true },
      { name: 'status', urlQuery: true },
    ]);
  },
  methods: {
    toggleStatus() {
      if (this.status === 'finished') {
        this.status = '';
      } else {
        this.status = 'finished';
      }
    },
  },
};
